module.exports = __webpack_public_path__ + "static/media/Asset 8RLHip.dfb03270.png";